var CLONOTYPES = 'clonotypes';

/**
 * Updates the cells sets shown to the user with the hierarchy fetched
 * from the API.
 */
var CLONOTYPES_LOADED = "".concat(CLONOTYPES, "/loaded");

/**
 * Signals to the UI that new cell set data is about to be loaded in.
 */
var CLONOTYPES_LOADING = "".concat(CLONOTYPES, "/loading");

/**
 * Creates an error condition in the cell set tool.
 */
var CLONOTYPES_ERROR = "".concat(CLONOTYPES, "/error");
export { CLONOTYPES_LOADED, CLONOTYPES_LOADING, CLONOTYPES_ERROR };